// import { news } from '../utils/constants'; // Commented out as not currently used
const NEWS_API_URL_ENDPOINT = `${process.env.REACT_APP_NEWS_API_URL}/banyanhill/news`;
const INSTAGRAM_FEED_ENDPOINT = `${process.env.REACT_APP_NEWS_API_URL}/banyanhill/instagram-feed`;
const PROJECT_API_URL_ENDPOINT = `${process.env.REACT_APP_NEWS_API_URL}/projects/?hostname=banyanhill.com.au`;
const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

const api = {
  getNews: async (page = 1) => {
    try {
      const response = await fetch(`${NEWS_API_URL_ENDPOINT}?page=${page}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
      // return news;
    } catch (error) {
      console.error('Error fetching news:', error);
      throw error;
    }
  },

  getNewsById: async (id) => {
    try {
      const response = await fetch(`${NEWS_API_URL_ENDPOINT}/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error(`Error fetching news with id ${id}:`, error);
      throw error;
    }
  },

  getInstagramPosts: async (limit = 25) => {
    try {
      const response = await fetch(`${INSTAGRAM_FEED_ENDPOINT}?limit=${limit}`);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      // Return the data as is, assuming the API already formats it correctly
      return data.map(post => ({
        ...post,
        source: 'instagram'
      }));
    } catch (error) {
      console.error('Error fetching Instagram posts:', error);
      throw error;
    }
  },

  getProject: async () => {
    try {
      const response = await fetch(`${PROJECT_API_URL_ENDPOINT}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  },

  getAllEnabledPackages: async () => {
    try {
      const response = await fetch(`${REACT_APP_API_URL}/packages-enabled`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      let data = await response.json();

      // Extract houses from the response based on the expected structure
      let houses = data.items || data;

      // Filter houses based on the logic from getUnsoldHouses selector
      houses = houses.filter(
        (house) =>
          house.lot?.status !== 'Unreleased' &&
          house.lot?.status !== 'Settled' &&
          house.lot?.status !== 'Sold' &&
          house.lot?.status !== 'Deposited'
      );

      return houses;
    } catch (error) {
      console.error('Error fetching all enabled packages:', error);
      throw error;
    }
  },
};

export default api;